import React, { PureComponent } from 'react'
import { array, string, number } from 'prop-types'
import { connect } from 'react-redux'
import SingleCluster from './SingleCluster'

class ClusterMarkers extends PureComponent {
  render() {
    let {
      category,
      coordinates,
      pointCount,
      clusterColor,
      theme,
      leaves,
      signs,
    } = this.props
    return (
      <SingleCluster
        coordinates={coordinates}
        category={category}
        clusterColor={clusterColor}
        theme={theme}
        pointCount={pointCount}
        leaves={leaves}
        signs={signs}
      />
    )
  }
}

ClusterMarkers.propTypes = {
  coordinates: array.isRequired,
  category: string.isRequired,
  pointCount: number.isRequired,
}

const mapStateToProps = ({ map, spi, signsState }) => ({
  clusterColor: map.clusterColor,
  theme: spi.theme,
  signs: signsState.signs,
})

export default connect(mapStateToProps)(ClusterMarkers)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/ClusterMarkers.jsx